import {connect} from '@modifi/redux'
import {compose} from 'ramda'
import {
  selectBankName,
  aFetchBankUtils,
  selectBankUtilsErrorMessage,
  aClearBankUtils,
} from '../../../../../data/bank-utils/entity'
import {selectSellerBankAccountIntermediaryBankName} from '../../../../../data/seller-bank-accounts'

import IntermediaryBankDetails, {IntermediaryBankDetailsProps} from './IntermediaryBankDetails'

const mapStateToProps = (
  state: Record<string, any>,
  ownProps: {bankAccountId: string}
): Pick<
  IntermediaryBankDetailsProps,
  'bankName' | 'bankUtilsErrorMessage' | 'persistedIntermediaryBankName'
> => ({
  bankName: selectBankName(state),
  bankUtilsErrorMessage: selectBankUtilsErrorMessage(state) || '',
  persistedIntermediaryBankName: selectSellerBankAccountIntermediaryBankName(
    state,
    ownProps?.bankAccountId
  ),
})

const mapDispatchToProps = {
  fetchBankDetails: aFetchBankUtils,
  resetBankUtils: aClearBankUtils,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(IntermediaryBankDetails)
